import { render, staticRenderFns } from "./DocUploader.vue?vue&type=template&id=b3bbbce8&scoped=true&"
import script from "./DocUploader.vue?vue&type=script&lang=js&"
export * from "./DocUploader.vue?vue&type=script&lang=js&"
import style0 from "./DocUploader.vue?vue&type=style&index=0&id=b3bbbce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bbbce8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
